import React from 'react';
import { node, object } from 'prop-types';
import { BQLink } from '../bqlink';

import { getStorySlug } from '../../../helpers/utils';

import './list-title.m.css';

const ListTitle = ({ children, story, color, fontSize, lineHeight, marginBottom, ...props }) => {
  if (!story) {
    return (
      <div styleName="list-title" className="truncate-overflow" style={{ fontSize, color, lineHeight, marginBottom }} {...props}>{children}</div>
    );
  } else {
    return (
      <BQLink story={story} href={getStorySlug(story)}>
        <h3 styleName="list-title" className="truncate-overflow" style={{ fontSize, color, lineHeight, marginBottom }} {...props}>{children}</h3>
      </BQLink>
    );
  }
};

ListTitle.propTypes = {
  children: node.isRequired,
  story: object,
};

ListTitle.defaultProps = {
  fontSize: 'var(--base)',
  color: 'var(--second-color)',
  lineHeight: '1.2',
  marginBottom: '0px',
};

export default ListTitle;
